import React from "react";
import { genClassName, SquareImgTile } from "@disco/disco_core";

import useWidgetOffer from "../../hooks/useWidgetOffer";
import useDimensions from "../../hooks/useDimensions";
import useTrack, { eventTypes } from "../../hooks/useTrack";
import getImgUrl from "../../utils/getImgUrl";
import { WIDGET_ELEMENT_CLICK_TARGET } from "../../event_conf";

const EngageOfferImage = () => {
	const { isLargeWidget } = useDimensions();
	const { activeOffer, defaultOfferEventProps } = useWidgetOffer();
	const track = useTrack();
	const width = isLargeWidget ? 128 : 96;

	// If the offer has any products with a non-empty photo_url, use that. Otherwise, fallback to the brand's logo_url
	const productWithPhotoUrl = activeOffer?.products?.find(
		(product) => product.photo_url
	);

	const imgSrc = productWithPhotoUrl
		? getImgUrl(productWithPhotoUrl, width, width)
		: getImgUrl(activeOffer, width, width, "logo_url");

	const handleProductClick = () => {
		track(eventTypes.WIDGET_ELEMENT_CLICK, {
			...defaultOfferEventProps,
			initiatingTarget: WIDGET_ELEMENT_CLICK_TARGET.INLINE_FOOTER_DISCO, // Using a temp target instead of creating a new target
		});
	};

	return (
		<SquareImgTile
			className={genClassName({
				base: "lead-gen-product",
			})}
			rounded
			bordered
			onClick={handleProductClick}
			src={imgSrc}
			width={`${width}px`}
		/>
	);
};

export default EngageOfferImage;
